var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"view-area"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_c('VButton',{staticClass:"btn-ghost",on:{"click":_setup.goBack}},[_vm._v(" Go Back ")])],1),_c('div',{staticClass:"col-6 all-notifications"},[_c(_setup.PaginatedNotifications,{attrs:{"type":"file_export"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }